import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {RoutingService, UrlFormatted} from '@core/services/routing.service';

import {RouterModule} from '@angular/router';
import {NgOptimizedImage, NgStyle} from '@angular/common';
import {RouterContextDirective} from '@core/directives/router-context.directive';

export interface SpotV2Obj {
  __typename?: 'FrontPageSpot';
  backgroundImage?: string;
  columnsLg?: string;
  columnsMd?: string;
  columnsSm?: string;
  ctaDesign?: string;
  ctaLink?: string;
  ctaText?: string;
  description?: string;
  height?: string;
  id?: string | number;
  placement?: string;
  title?: string;
  imgHeight?: number;
  imgWidth?: number;
}

@Component({
  selector: 'app-storyblok-spot-v2',
  templateUrl: './storyblok-spot-v2.component.html',
  styleUrls: ['./storyblok-spot-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, RouterModule, NgOptimizedImage, RouterContextDirective]
})
export class StoryblokSpotV2Component {
  url: UrlFormatted | undefined;
  private routingService = inject(RoutingService);

  private _spot: SpotV2Obj;

  get spot(): SpotV2Obj {
    return this._spot;
  }

  @Input()
  set spot(value: SpotV2Obj) {
    if (value?.ctaLink?.startsWith('/sv')) {
      value.ctaLink = '';
    }
    this._spot = value;
    this.url = this.routingService.getUrlFormattedObjectByPath(<string>value?.ctaLink);
  }

  get style() {
    const style: any = {};

    if (this.spot?.height) {
      style.height = `${this.spot.height}px`;
    }

    return style;
  }

}
